import React, {Component} from "react";
import {Bar} from 'react-chartjs-2';

export const DEFAULT_BAR_COLOR = '#3799FF';

type DataValues = (number|null)[]|{[index:string]:any}[];
type DataSet = DataValues|{data: DataValues};

export interface TooltipItem {
  dataIndex: number;
  label: string;
  raw: any;
}

interface BarChartProps {
  data: DataSet[],
  aspectRatio?: number;
  xAxis: {labels: string[]};
  yAxis?: {title?: string, renderLabel?:(value:number, index: number)=>string|null};
  tooltip?: {renderTitle?:(items:TooltipItem[])=>string|null, renderLabel?:(item:TooltipItem)=>string|null}
}

export default class BarChart extends Component<BarChartProps, {}> {
  static formatDataSet(dataSet: DataSet) {
    if(Array.isArray(dataSet)) {
      return {
        data: dataSet,
        backgroundColor: DEFAULT_BAR_COLOR
      };
    } else {
      const dataSetOptions: any = {
        data: dataSet.data,
        backgroundColor: DEFAULT_BAR_COLOR
      };
      return dataSetOptions;
    }
  }

  render() {
    const data = {
      labels: this.props.xAxis.labels,
      datasets: this.props.data.map(BarChart.formatDataSet)
    };
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          displayColors: false,
          titleColor: '#000000',
          bodyColor: '#000000',
          backgroundColor: '#FFFFFF',
          borderWidth: 1,
          callbacks: {
            title: this.props.tooltip?.renderTitle,
            label: this.props.tooltip?.renderLabel,
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false
          }
        },
        y: {
          grid: {
            borderDash: [10, 10],
            tickWidth: 0,
            tickLength: 20,
            drawBorder: false
          },
          title: {
            display: !!this.props.yAxis?.title,
            text: this.props.yAxis?.title
          },
          ticks: {
            callback: this.props.yAxis?.renderLabel
          }
        }
      }
    };
    return <div className="chart bar-chart">
      <Bar type="line" data={data} options={options} />
    </div>;
  }
}